import React, { useState } from 'react';
import NotizenAufgaben from './NotizenAufgaben';
import AnhangPanel from './AnhangPanel';
import DokumenteKarte from './DokumenteKarte';
import Timeline from './Timeline';

interface AktivitaetenBlockProps {
  /** Muss dem Audit-Tabellennamen entsprechen (z.B. "artikel", "bestellung"),
      sonst zeigt die Timeline keine Systemereignisse. */
  entitaetTyp: string;
  entitaetId: number;
  /** Beleg-Archiv (DokumenteKarte) mit anzeigen — nur für "partner"/"auftrag"/"vertrag"
      sinnvoll, nur dort existieren Beleg-Referenzen. */
  mitBelegen?: boolean;
}

const AktivitaetenBlock: React.FC<AktivitaetenBlockProps> = ({
  entitaetTyp,
  entitaetId,
  mitBelegen = false,
}) => {
  const authToken = localStorage.getItem('auth_token') || '';
  const [rev, setRev] = useState(0);
  const bump = () => setRev(r => r + 1);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <NotizenAufgaben entitaetTyp={entitaetTyp} entitaetId={entitaetId} authToken={authToken} onChange={bump} />
      <AnhangPanel entitaetTyp={entitaetTyp} entitaetId={entitaetId} authToken={authToken} onChange={bump} />
      {mitBelegen && entitaetTyp === 'partner' && (
        <DokumenteKarte partnerId={entitaetId} authToken={authToken} />
      )}
      {mitBelegen && entitaetTyp === 'auftrag' && (
        <DokumenteKarte auftragId={entitaetId} authToken={authToken} />
      )}
      {mitBelegen && entitaetTyp === 'vertrag' && (
        <DokumenteKarte vertragId={entitaetId} authToken={authToken} />
      )}
      <Timeline key={rev} entitaetTyp={entitaetTyp} entitaetId={entitaetId} authToken={authToken} />
    </div>
  );
};

export default AktivitaetenBlock;
